"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callPluginsMethod = callPluginsMethod;
function callPluginsMethod(plugins, methodName, parameter) {
    if (!plugins) {
        return;
    }
    for (const plugin of plugins) {
        const method = plugin[methodName];
        if (method) {
            method(parameter);
        }
    }
}
//# sourceMappingURL=plugins.js.map